<template id="customerLogin">
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <div class="card">
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-5"> {{ $t('Customer.customerLogin.Login') }}</h1>
          <el-form ref="loginmodel" :rules="loginRules" :model="loginmodel">
            <el-form-item prop="name">
              <el-input
                v-model="loginmodel.name"
                suffix-icon="el-icon-s-custom"
                :placeholder="$t('Customer.customerLogin.user')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :placeholder="$t('Customer.customerLogin.password')"
                suffix-icon="el-icon-key"
                v-model="loginmodel.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked"> {{ $t('Customer.customerLogin.loggedin') }}</el-checkbox>
              <router-link :to="{ name: 'forgotPassword' }">
                <el-link style="float: right" type="success"
                  > {{ $t('Customer.customerLogin.Forgopassword') }}</el-link
                >
              </router-link>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="login('loginmodel')"
                class="btn btn-block btn-primary btn-lg mb-3"
              >
                 {{ $t('Customer.customerLogin.Login') }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <p class="text-center mb-0">
                 {{ $t('Customer.customerLogin.registerEmail') }}<router-link :to="{ name: 'registerEmail' }"
                  > {{ $t('Customer.customerLogin.register') }}</router-link
                >
              </p>
            </el-form-item>
            <el-form-item>
              <div class="additional-row mb-4">
                <span class="additional-text"> {{ $t('Customer.customerLogin.or') }}</span>
              </div>
              <el-button
                type="primary"
                icon="fab fa-facebook"
                @click="onFBLogin()"
                class="btn btn-block fb-login-button btn-lg"
                > {{ $t('Customer.customerLogin.Facebook') }}</el-button
              >
              <!-- <a href="#" class="btn btn-block fb-login-button btn-lg">
                <i class="fab fa-facebook mr-2"></i> 以 Facebook 帳號登入
              </a> -->
            </el-form-item>
          </el-form>
          <!-- /.social-auth-links -->
        </div>
        <!-- /.float-card-body -->
      </div>
    </div>
    <!-- ./float box -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import socketTools from "../../assets/js/websocketTools";
export default {
  data() {
    return {
      checked: true,
      loginmodel: {
        name: "",
        password: "",
      },
      loginRules: {
        name: [
          { required: true, message:this.$t('Customer.customerLogin.loginRules.name'), trigger: "blur" },
        ],
        password: [{ required: true, message: this.$t('Customer.customerLogin.loginRules.password'), trigger: "blur" }],
      },
    };
  },
   watch: {
    //监听语言切换
    '$i18n.locale'() {
      this.setloginRules();
    },
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.loadFBSDK();
    this.setloginRules();
  },
  methods: {
    setloginRules(){
      this.loginRules = {
        name: [
          { required: true, message: this.$t('Customer.customerLogin.loginRules.name'), trigger: "blur" },
        ],
        password: [{ required: true, message: this.$t('Customer.customerLogin.loginRules.password'), trigger: "blur" }],
      }
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            name: this.loginmodel.name,
            pwd: this.loginmodel.password,
          };
          this.$store.dispatch("userlogin", params).then((res) => {
            this.loginbtn = false;
            if (res == true) {
              this.user = this.$store.getters.getcustomer;
              localStorage.setItem("userinfo", JSON.stringify(this.user));
              // this.$cookie.set('userinfo', JSON.stringify(this.user), 1, null, '.soonnet.org');
              // this.$cookie.set('token', JSON.stringify(this.user.accessToken), 1, null,'.soonnet.org');
              this.$cookies_.setItem('userinfo', JSON.stringify(this.user), 1000 * 60 * 60 * 24, null, '.soonnet.org');
              this.$cookies_.setItem('token', JSON.stringify(this.user.accessToken), 1000 * 60 * 60 * 24,null, '.soonnet.org');
              if (
                this.user != null &&
                this.user.userId != undefined &&
                this.user.userId != ""
              ) {
                // location.reload();
                // this.$router.go(-1);
                //this.$router.push({ name: "customerPublish" });
                //sessionStorage.setItem("websocketId", this.user.userId);
                // socketTools.initWebsocket(0);
                if (this.$route.query.redirect) {
                  //如果存在参数
                  let redirect = this.$route.query.redirect;
                  this.$router.push(redirect); //则跳转至进入登录页前的路由
                } else {
                  this.$router.push({ name: "Index" }); //否则跳转至首页
                }
              }
            } else {
              Message({
                type: "error",
                message: "登錄失敗,請檢查用戶名密碼",
              });
            }
          });
        } else {
          Message({
            type: "error",
            message: "請檢查用戶名密碼",
          });
        }
      });
    },
    loadFBSDK() {
      /* console.log("加载");
      const params =
        "#version=v3.3&appId=504404792941839&status=true&cookie=true&xfbml=true&autoLogAppEvents=true";
      (function (d, s, id) {
        // Load the SDK asynchronously
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/zh_TW/sdk.js" + params;
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk"); */
    },
    //fb登录请求
    // FBLogin() {
    //   FB.login(
    //     function (response) {
    //       if (response.authResponse) {
    //         console.log("Welcome!  Fetching your information.... ");
    //         $("#LokOverlay").fadeIn();
    //         $("#LoadingGif").fadeIn();
    //         $("body").css("overflow", "hidden");
    //         var fd = new FormData();
    //         fd.append("AccessToken", response.authResponse.accessToken);
    //         $.ajax({
    //           url: "/Web_Data/FacebookSDK.ashx",
    //           data: fd,
    //           cache: false,
    //           contentType: false,
    //           processData: false,
    //           type: "POST",
    //           success: function (data) {
    //             console.log("data:" + data);
    //             $("#<%= LokRefreshButton.ClientID %>").click();
    //           },
    //           error: function (jqXHR, textStatus, errorThrown) {
    //             alert(textStatus + ":" + errorThrown);
    //           },
    //         });
    //       } else {
    //         console.log("--------------.... ");
    //       }
    //     },
    //     { scope: "public_profile,email,user_birthday" }
    //   );
    // },
    onFBLogin() {
      console.log("进入方法", FB);
      this.loadFBSDK();
      const _this = this;
      // 检测FB登录状态
      FB.getLoginStatus(function (response) {
        // statusChangeCallback(response);
        console.log("请求成功", response);
        if (response.status === "connected") {
          let params = {
            accessToken: response.authResponse.accessToken,
            userID: response.authResponse.userID,
            expiresIn: response.authResponse.expiresIn,
            signedRequest: response.authResponse.signedRequest,
          };
          console.log(params.accessToken);
          _this.$store.dispatch("userlogin", params).then((res) => {
            console.log(res);
            _this.loginbtn = false;
            if (res == true) {
              _this.user = _this.$store.getters.getcustomer;
              localStorage.setItem("userinfo", JSON.stringify(_this.user));
              if (
                _this.user != null &&
                _this.user.userId != undefined &&
                _this.user.userId != ""
              ) {
                // location.reload();
                // this.$router.go(-1);
                _this.$router.push({ name: "customerPublish" });
              }
            } else {
              Message({
                type: "error",
                message: "登錄失敗,請檢查用戶名密碼",
              });
            }
          });
          //#region login
          // $("#LokOverlay").fadeIn();
          // $("#LoadingGif").fadeIn();
          // $("body").css("overflow", "hidden");
          // var fd = new FormData();
          // fd.append("AccessToken", response.authResponse.accessToken);
          // $.ajax({
          //   url: "/Web_Data/FacebookSDK.ashx",
          //   data: fd,
          //   cache: false,
          //   contentType: false,
          //   processData: false,
          //   type: "POST",
          //   success: function (data) {
          //     console.log("data:" + data);
          //     $("#<%= LokRefreshButton.ClientID %>").click();
          //   },
          //   error: function (jqXHR, textStatus, errorThrown) {
          //     alert(textStatus + ":" + errorThrown);
          //   },
          // });
          // 已登录0
          // Has logged into your webpage and Facebook.
          // _this.handleSomething();
          // } else if (response.status === "not_authorized") {
          //   this.FBLogin();
          //   console.log("Logged.is logged but not authenticated.");
          //   //alert('Logged.is logged but not authenticated.');
          // } else {
          //   FBLogin();
          //   console.log("Logged.Is not loginddd.");
          //#endregion
        } else {
          // 未登录进行登录
          FB.login(
            function (response) {
              console.log(response);
              console.log(222);
              if (response.status === "connected") {
                let params = {
                  accessToken: response.authResponse.accessToken,
                  userID: response.authResponse.userID,
                  expiresIn: response.authResponse.expiresIn,
                  signedRequest: response.authResponse.signedRequest,
                };
                console.log(params.accessToken);
                _this.$store.dispatch("userlogin", params).then((res) => {
                  console.log(res);
                  _this.loginbtn = false;
                  if (res == true) {
                    _this.user = _this.$store.getters.getcustomer;
                    localStorage.setItem(
                      "userinfo",
                      JSON.stringify(_this.user)
                    );
                    if (
                      _this.user != null &&
                      _this.user.userId != undefined &&
                      _this.user.userId != ""
                    ) {
                      // location.reload();
                      // this.$router.go(-1);
                      _this.$router.push({ name: "customerPublish" });
                    }
                  } else {
                    Message({
                      type: "error",
                      message: "登錄失敗,請檢查用戶名密碼",
                    });
                  }
                });

                // Logged into your webpage and Facebook.
                // _this.handleSomething();
              } else {
                console.log("登录失败");

                // The person is not logged into your webpage or we are unable to tell.
              }
            }
            ,{ scope: "public_profile,email,user_likes", return_scopes: true }
          );
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Customer/customerLogin.vue